/**
 * @format
 * @flow strict-local
 */
// DEPENDENCIES

import React, {
	useEffect,
	useState
} from "react";
import {
	connect
} from "react-redux";
import {
	useNavigate
} from "react-router-dom";

import {} from "./Dashboard.styled";

import i18nHelper from "../../helpers/i18n";
import routerHelper from "../../helpers/router";
import storeHelper from "../../helpers/store";
import utilsHelper from "../../helpers/utils";

//import useApi from "../../hooks/api";

import i18n from "../../i18n";

// INIT

/**
 * mapStateToProps - ...
 * 
 * @param {object} state ...
 */
const mapStateToProps = (state) => {
	return {
		...state
	};
};

// COMPONENT

const Dashboard = (props) => {
	const navigate = useNavigate();

	// Lifecycle

	useEffect(
		() => {}, 
		[]
	);

	// Events

	/**
	 * accountClickHandler - ...
	 * 
	 * @param {object} e ... 
	 */
	const accountClickHandler = (e) => {
		navigate({
			pathname: routerHelper.getUrl("account")
		});
	};

	/**
	 * copsClickHandler - ...
	 * 
	 * @param {object} e ... 
	 */
	const copsClickHandler = (e) => {
		navigate({
			pathname: routerHelper.getUrl("cops")
		});
	};

	/**
	 * listsClickHandler - ...
	 * 
	 * @param {object} e ... 
	 */
	const listsClickHandler = (e) => {
		navigate({
			pathname: routerHelper.getUrl("lists")
		});
	};

	// Render

	const render = () => {
		return (
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					gap: "48px",
					padding: "48px"
				}}
				>
				<h1>Dashboard</h1>
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						gap: "24px"
					}}
					>
					<a
						onClick={accountClickHandler}
						>
						Account
					</a>
					<a
						onClick={copsClickHandler}
						>
						Cops
					</a>
					<a
						onClick={listsClickHandler}
						>
						Lists
					</a>
				</div>
			</div>
		);
	};

	return render();
};

// EXPORT

export default connect(mapStateToProps)(Dashboard);
